import React, { useEffect } from 'react';
import './App.css';
import { useSelector } from 'react-redux'
import Ortho from './Routes/Ortho.jsx'
import NewOrtho from './Routes/NewOrtho.jsx'
import PotreePage from './Routes/PotreePage.jsx'
import PhotoViewer from './Routes/PhotoViewer.jsx'
import UsersPage from './Routes/UsersPage.jsx'
import ProjectsPage from './Routes/ProjectsPage.jsx'
import AnnotationTablePage from './Routes/AnnotationTablePage.jsx'
import AccessTrackingPage from './Routes/AccessTrackingPage.jsx'
import ViewEditorPage from './Routes/ViewEditorPage.jsx'
import CsvImporterPage from './Routes/CsvImporterPage.jsx'

import { selectCurrentOffice, selectCurrentUserId } from './app/auth.js'
import { selectTopbarTitle } from './app/interface.js'
import { getDefaultDocumentTitle } from './app/branding.js'

import { Navigate } from 'react-router-dom';

import MainLayout from './Layouts/MainLayout'
import OnlyTopBarLayout from './Layouts/OnlyTopBarLayout'
import NoLayout from './Layouts/NoLayout'

import {
  Routes,
  Route,
} from "react-router-dom";

// authentication Wrapper
import AuthenticateUser from './AuthenticateUser.jsx'
import ProjectsEditPage from './Routes/ProjectsEditPage';


const VERSION = "0.0.1"

function Landing(){
    return <Navigate to={`/projects`} replace />;
}

function App() {
  const currentOffice = useSelector(selectCurrentOffice)
  const currentUserId = useSelector(selectCurrentUserId)
  const topbarTitle = useSelector(selectTopbarTitle)

  useEffect(() => {
    document.title = topbarTitle || getDefaultDocumentTitle()
  }, [topbarTitle])

  return (
    <div className="App">
      <AuthenticateUser >
        <Routes>
          <Route element={<MainLayout/>}>
            <Route path="/projects/access_tracking" element={<AccessTrackingPage />} />
            <Route path="/ortho/new" element={<NewOrtho />}/>
            <Route path="/users" element={<UsersPage />} />
            <Route index={true} path="/projects" element={<ProjectsPage />}/>
            <Route path="/projects/edit/:id" element={<ProjectsEditPage />} />
            <Route path="/view_editor" element={<ViewEditorPage />} />
            <Route path="/" element={<Landing />}/>  
            <Route path="/csv_importer" element={<CsvImporterPage />} />
          </Route>
          <Route element={<OnlyTopBarLayout/>}>
            <Route path="/ortho" element={<Ortho />} />
            <Route path="/photo-viewer" element={<PhotoViewer />} />
            <Route path="/3D" element={<PotreePage />} />
          </Route>
          <Route element={<NoLayout/>}>
            <Route path="/annotations" element={<AnnotationTablePage />} />
          </Route>
        </Routes>
      </AuthenticateUser>
    </div>
  );
}

export default App;
